/* SelmaCilek: telefonda ekranı kaplayan paneller aşağı çekilerek kapanır — her sayfada sc-announcement ile yüklenir (defer).
   Panelin içeriği en üstteyken (scrollTop 0) parmakla aşağı çekilince panel parmağı izler; ~90 px'den fazla çekilir ya da
   hızlıca fırlatılırsa panelin kendi kapatma düğmesine tıklanır (odak, kaydırma kilidi, arka plan temizliği panelin kendi
   kodunda kalır), yoksa yerine yaylanır. X düğmesi aynen durur. Yalnızca dokunma; yatay kaydırmalara (fotoğraf şeritleri,
   tablolar, kaydırıcılar) ve panel kapalıyken sayfa kaydırmasına dokunulmaz. "Hareketi azalt" tercihinde animasyon yok.
   Kapsam: ürün sayfası beden seçimi + beden rehberi (.scp-sheet), Impulse çekmeceleri (menü, sepet, filtre) ve pencereleri
   (hızlı bakış, video). Yeni bir panel için KINDS'e bir satır eklemek yeter; bir öğeyi hariç tutmak için data-sc-sheet-ignore. */
(function () {
  'use strict';
  if (window.__scSheet) return;
  window.__scSheet = true;

  var KINDS = [
    // ürün sayfası: alttan açılan beden seçimi ve beden rehberi (900 px altında)
    { sel: '.scp-sheet', on: 'on', close: '[data-close]', mq: '(max-width: 899px)', scrim: '#scpScrim' },
    // Impulse çekmeceleri: menü, sepet, filtre
    { sel: '.drawer', on: 'drawer--is-open', close: '.js-drawer-close', mq: '(max-width: 768px)' },
    // Impulse pencereleri: hızlı bakış, video (hareket eden kutu: .modal__inner)
    { sel: '.modal', on: 'modal--is-active', close: '.js-modal-close', mq: '(max-width: 768px)', move: '.modal__inner' }
  ];
  var SEL = KINDS.map(function (k) { return k.sel; }).join(',');
  var DIST = 90, FLICK = 0.5, SLOP = 6; // px, px/ms, px
  var IGNORE = 'input, select, textarea, [contenteditable], [role="slider"], [data-sc-sheet-ignore]';
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var g = null; // süren hareket

  function kindOf(el) {
    for (var i = 0; i < KINDS.length; i++) if (el.matches(KINDS[i].sel)) return KINDS[i];
    return null;
  }
  function later(f, ms) { if (ms) setTimeout(f, ms); else f(); }

  // dokunulan yerden panele kadar kaydırılmış bir kutu varsa (içerik en üstte değil) kapatma hareketi başlamaz
  function scrolled(t, root) {
    for (var el = t; el && el.nodeType === 1; el = el.parentElement) {
      if (el.scrollTop > 0) return true;
      if (el === root) break;
    }
    return false;
  }

  function start(e) {
    var root = e.currentTarget, k = root.__scSheet;
    if (g || !k || e.touches.length !== 1 || !root.classList.contains(k.on) || !window.matchMedia(k.mq).matches) return;
    var t = e.target;
    if (!t.closest || t.closest(IGNORE) || (k.move && !t.closest(k.move)) || scrolled(t, root)) return;
    var mv = k.move ? root.querySelector(k.move) : root;
    if (!mv) return;
    var p = e.touches[0];
    g = { root: root, k: k, mv: mv, x: p.clientX, y: p.clientY, on: false, d: 0, pts: [] };
  }

  function move(e) {
    if (!g || g.root !== e.currentTarget) return;
    var p = e.touches[0], dx = p.clientX - g.x, dy = p.clientY - g.y;
    if (!g.on) {
      if (Math.abs(dx) < SLOP && Math.abs(dy) < SLOP) return;
      // aşağı yönlü dikey hareket değilse bırak: içerik normal kayar, yatay şerit çalışır
      if (dy <= 0 || Math.abs(dx) > Math.abs(dy)) { g = null; return; }
      g.on = true; g.y0 = p.clientY;
      g.h = g.mv.offsetHeight || window.innerHeight;
      g.sc = g.k.scrim ? document.querySelector(g.k.scrim) : null;
      g.mv.style.transition = 'none';
      if (g.sc) g.sc.style.transition = 'none';
    }
    if (e.cancelable) e.preventDefault();
    var d = Math.max(0, p.clientY - g.y0);
    g.d = d;
    g.pts.push([p.clientY, e.timeStamp]); // hız için son ~100 ms
    while (g.pts.length > 2 && e.timeStamp - g.pts[0][1] > 100) g.pts.shift();
    g.mv.style.translate = '0 ' + d + 'px';
    if (g.sc) g.sc.style.opacity = String(Math.max(0, 1 - d / g.h));
  }

  function end(e) {
    if (!g || g.root !== e.currentTarget) return;
    var s = g, mv = s.mv, sc = s.sc;
    g = null;
    if (!s.on) return;
    var a = s.pts[0], b = s.pts[s.pts.length - 1], span = a ? b[1] - a[1] : 0;
    var v = span >= 20 ? (b[0] - a[0]) / span : 0; // px/ms, aşağı pozitif
    var shut = e.type === 'touchend' && (s.d > DIST || (v > FLICK && s.d > 24));
    var ms = calm.matches ? 0 : shut ? 200 : 260;
    mv.style.transition = ms ? 'translate ' + ms + 'ms ' + (shut ? 'cubic-bezier(.4,0,1,1)' : 'cubic-bezier(.2,.8,.2,1)') : 'none';
    if (sc) sc.style.transition = ms ? 'opacity ' + ms + 'ms' : 'none';
    if (!shut) { // yerine yaylan
      mv.style.translate = '';
      if (sc) sc.style.opacity = '';
      later(function () { mv.style.transition = ''; if (sc) sc.style.transition = ''; }, ms);
      return;
    }
    mv.style.translate = '0 ' + Math.max(window.innerHeight, s.h) + 'px';
    if (sc) sc.style.opacity = '0';
    later(function () {
      // panelin kendi kapatma düğmesi: odak, kaydırma kilidi ve arka plan temizliği onun kodunda
      mv.style.transition = '';
      if (sc) { sc.style.transition = ''; sc.style.opacity = ''; }
      var b = s.root.querySelector(s.k.close);
      if (b) b.click();
      setTimeout(function () { mv.style.translate = ''; }, 600);
    }, ms);
  }

  function bind(el) {
    if (el.__scSheet) return;
    var k = kindOf(el);
    if (!k) return;
    el.__scSheet = k;
    el.addEventListener('touchstart', start, { passive: true });
    el.addEventListener('touchmove', move, { passive: false }); // yalnızca panelin üstünde; sayfa kaydırması etkilenmez
    el.addEventListener('touchend', end, { passive: true });
    el.addEventListener('touchcancel', end, { passive: true });
  }
  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches(SEL)) bind(root);
    var l = root.querySelectorAll(SEL);
    for (var i = 0; i < l.length; i++) bind(l[i]);
  }

  // sonradan eklenen paneller (filtre / sayfalama ile gelen hızlı bakış pencereleri vb.)
  var pending = [], sched = 0;
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var add = muts[i].addedNodes;
      for (var j = 0; j < add.length; j++) if (add[j].nodeType === 1) pending.push(add[j]);
    }
    if (pending.length && !sched) sched = requestAnimationFrame(function () {
      sched = 0;
      var list = pending; pending = [];
      for (var n = 0; n < list.length; n++) if (list[n].isConnected) scan(list[n]);
    });
  });
  function init() {
    scan(document.body);
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) init(); else document.addEventListener('DOMContentLoaded', init);
})();
